import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function Terms() {
  useSEO({
    title: 'Allgemeine Geschäftsbedingungen (AGB) - EarnProof',
    description: 'Allgemeine Geschäftsbedingungen und Nutzungsbedingungen für EarnProof.org.',
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-gray-950">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-900/20 to-cyan-900/20"></div>
        <div className="relative max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Allgemeine Geschäftsbedingungen
            <span className="block text-2xl md:text-3xl text-teal-400 font-normal mt-2">
              Nutzungsbedingungen für EarnProof.org
            </span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Rechtliche Rahmenbedingungen für die Nutzung unserer Plattform und Services.
          </p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-900/50 border border-gray-700 rounded-xl p-8 space-y-8">
            
            {/* § 1 Geltungsbereich */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 1 Geltungsbereich</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der Website EarnProof.org 
                  und aller damit verbundenen Services. Betreiber ist Christopher Humpert, 
                  Gutenbergstraße 34, 46045 Oberhausen.
                </p>
                <p>
                  Mit der Nutzung unserer Website erklären Sie sich mit diesen AGB einverstanden. 
                  Abweichende Bedingungen werden nicht anerkannt, es sei denn, wir haben ihrer Geltung 
                  ausdrücklich schriftlich zugestimmt.
                </p>
              </div>
            </div>

            {/* § 2 Leistungsbeschreibung */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 2 Leistungsbeschreibung</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  EarnProof.org ist eine Informationsplattform, die ehrliche Reviews und Bewertungen 
                  von Earning-Apps, Crypto-Tools und anderen Online-Verdienstmöglichkeiten bereitstellt.
                </p>
                <p>Unsere Leistungen umfassen:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Detaillierte App-Reviews mit Auszahlungsbeweisen</li>
                  <li>Transparente Einnahmen-Dokumentation</li>
                  <li>Aufklärung über Scams und unseriöse Angebote</li>
                  <li>Affiliate-Links zu empfohlenen Plattformen</li>
                  <li>Community-Support und Beratung</li>
                </ul>
                <p>
                  Alle Inhalte dienen ausschließlich der Information und stellen keine Anlageberatung dar.
                </p>
              </div>
            </div>

            {/* § 3 Nutzungsrechte und -pflichten */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 3 Nutzungsrechte und -pflichten</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Die Nutzung von EarnProof.org ist kostenfrei. Sie erhalten ein einfaches, 
                  nicht übertragbares Nutzungsrecht für die bereitgestellten Inhalte.
                </p>
                <p>Als Nutzer verpflichten Sie sich:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Die Website nur für legale Zwecke zu nutzen</li>
                  <li>Keine schädlichen Inhalte oder Malware zu verbreiten</li>
                  <li>Die Urheberrechte und geistigen Eigentumsrechte zu respektieren</li>
                  <li>Keine automatisierten Systeme zur Datensammlung zu verwenden</li>
                  <li>Ehrliches Feedback und konstruktive Kritik zu äußern</li>
                </ul>
              </div>
            </div>

            {/* § 4 Affiliate-Links und Vergütung */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 4 Affiliate-Links und Vergütung</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  EarnProof.org finanziert sich über Affiliate-Partnerschaften. Links zu empfohlenen 
                  Apps und Plattformen können Affiliate-Links sein, über die wir eine Provision erhalten.
                </p>
                <p>Wichtige Hinweise:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Für Sie entstehen durch Affiliate-Links keine zusätzlichen Kosten</li>
                  <li>Oft erhalten Sie über unsere Links sogar Boni oder Startvorteile</li>
                  <li>Alle Affiliate-Partnerschaften werden transparent kommuniziert</li>
                  <li>Unsere Bewertungen bleiben unabhängig und ehrlich</li>
                  <li>Wir empfehlen nur Apps und Services, die wir selbst getestet haben</li>
                </ul>
              </div>
            </div>

            {/* § 5 Haftungsausschluss */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 5 Haftungsausschluss</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Alle Inhalte auf EarnProof.org dienen ausschließlich der Information. 
                  Wir übernehmen keine Gewähr für die Richtigkeit, Vollständigkeit oder Aktualität 
                  der bereitgestellten Informationen.
                </p>
                <p>Ausgeschlossen ist unsere Haftung für:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Verluste durch die Nutzung empfohlener Apps oder Services</li>
                  <li>Änderungen bei Partner-Plattformen (Auszahlungsraten, Bedingungen, etc.)</li>
                  <li>Technische Probleme oder Ausfälle von Drittanbieter-Services</li>
                  <li>Entscheidungen basierend auf unseren Informationen</li>
                </ul>
                <p>
                  Die Haftung für Vorsatz und grobe Fahrlässigkeit bleibt unberührt. 
                  Earning-Apps bergen grundsätzlich Risiken - investieren Sie nur, was Sie verlieren können.
                </p>
              </div>
            </div>

            {/* § 6 Urheberrecht */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 6 Urheberrecht</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Alle Inhalte auf EarnProof.org (Texte, Bilder, Screenshots, Videos) sind urheberrechtlich 
                  geschützt und Eigentum von Christopher Humpert oder entsprechend lizenziert.
                </p>
                <p>Ohne ausdrückliche Genehmigung ist untersagt:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Kommerzielle Nutzung unserer Inhalte</li>
                  <li>Vervielfältigung oder Weiterverbreitung</li>
                  <li>Verwendung für eigene Websites oder Projekte</li>
                  <li>Bearbeitung oder Verfälschung von Screenshots</li>
                </ul>
                <p>
                  Zitate und kurze Ausschnitte für private oder wissenschaftliche Zwecke sind unter 
                  Quellenangabe gestattet.
                </p>
              </div>
            </div>

            {/* § 7 Datenschutz */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 7 Datenschutz</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Details zur Datenerhebung, 
                  -speicherung und -verarbeitung finden Sie in unserer separaten Datenschutzerklärung.
                </p>
                <p>Grundsätze:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Datenminimierung - wir erheben nur notwendige Daten</li>
                  <li>Zweckbindung - Daten werden nur für angegebene Zwecke verwendet</li>
                  <li>Keine Weitergabe an Dritte ohne Ihre Einwilligung</li>
                  <li>Sichere Verschlüsselung und Speicherung</li>
                </ul>
              </div>
            </div>

            {/* § 8 Änderungen der AGB */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 8 Änderungen der AGB</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Wir behalten uns vor, diese AGB bei Bedarf zu ändern. Änderungen werden auf 
                  der Website veröffentlicht und gelten ab dem Zeitpunkt der Veröffentlichung.
                </p>
                <p>
                  Bei wesentlichen Änderungen werden registrierte Nutzer per E-Mail informiert. 
                  Widersprechen Sie den Änderungen nicht innerhalb von 4 Wochen, 
                  gelten sie als genehmigt.
                </p>
              </div>
            </div>

            {/* § 9 Kündigung und Sperrung */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 9 Kündigung und Sperrung</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Sie können die Nutzung unserer Website jederzeit ohne Kündigung beenden. 
                  Gespeicherte Daten werden entsprechend unserer Datenschutzerklärung behandelt.
                </p>
                <p>
                  Wir behalten uns vor, Nutzer bei Verstößen gegen diese AGB zu sperren, 
                  insbesondere bei:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Missbrauch unserer Services</li>
                  <li>Verbreitung schädlicher Inhalte</li>
                  <li>Verletzung von Urheberrechten</li>
                  <li>Belästigung anderer Nutzer</li>
                </ul>
              </div>
            </div>

            {/* § 10 Schlussbestimmungen */}
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">§ 10 Schlussbestimmungen</h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. 
                  Gerichtsstand für alle Streitigkeiten ist Oberhausen.
                </p>
                <p>
                  Sollten einzelne Bestimmungen dieser AGB unwirksam sein, 
                  berührt dies die Wirksamkeit der übrigen Bestimmungen nicht.
                </p>
                <p>
                  Kontakt für rechtliche Fragen: hello@earnproof.org
                </p>
              </div>
            </div>

            {/* Stand */}
            <div className="border-t border-gray-700 pt-6">
              <p className="text-sm text-gray-400">
                <strong>Stand:</strong> Januar 2025<br />
                <strong>Letzte Aktualisierung:</strong> 01.01.2025
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900/30">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Fragen zu den AGB?</h2>
          <p className="text-xl text-gray-300 mb-8">
            Bei rechtlichen Fragen oder Unklarheiten können Sie sich jederzeit an uns wenden.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="mailto:hello@earnproof.org"
              className="inline-flex items-center justify-center px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-lg transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              E-Mail senden
            </a>
            <a 
              href="/contact"
              className="inline-flex items-center justify-center px-6 py-3 border border-teal-600 text-teal-400 hover:bg-teal-600 hover:text-white font-medium rounded-lg transition-colors whitespace-nowrap"
            >
              <i className="ri-customer-service-line mr-2"></i>
              Kontakt-Seite
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}